import type { ReactElement } from "react";

import type { TIconProps } from "../types";

export const MicrosoftExcel = (props: TIconProps): ReactElement => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#microsoftexcel_clip0_439_72406)">
      <path
        d="M15.6975 11.419L5.81372 9.67593V22.5558C5.81372 23.144 6.29085 23.6208 6.87943 23.6208H23.9343C24.5228 23.6208 25 23.144 25 22.5558V17.8104L15.6975 11.419Z"
        fill="hsl(from hsl(147 55% 29%) h s 30%)"
      />
      <path
        d="M15.6975 0.379364H6.87943C6.29085 0.379364 5.81372 0.856195 5.81372 1.4444V6.18972L15.6975 12.0001L20.9302 13.7432L25 12.0001V6.18972L15.6975 0.379364Z"
        fill="hsl(from hsl(147 55% 29%) h s 51%)"
      />
      <path
        d="M5.81372 6.18973H15.6975V12.0001H5.81372V6.18973Z"
        fill="hsl(from hsl(147 55% 29%) h s 38%)"
      />
      <path
        opacity="0.1"
        d="M12.8876 5.02765H5.81372V19.5535H12.8876C13.4754 19.5516 13.9514 19.0759 13.9533 18.4885V6.09269C13.9514 5.50528 13.4754 5.02956 12.8876 5.02765Z"
        fill="black"
      />
      <path
        opacity="0.2"
        d="M12.3062 5.60867H5.81372V20.1346H12.3062C12.894 20.1327 13.37 19.6569 13.3719 19.0695V6.67371C13.37 6.0863 12.894 5.61058 12.3062 5.60867Z"
        fill="black"
      />
      <path
        opacity="0.2"
        d="M12.3062 5.60867H5.81372V18.9725H12.3062C12.894 18.9706 13.37 18.4949 13.3719 17.9075V6.67371C13.37 6.0863 12.894 5.61058 12.3062 5.60867Z"
        fill="black"
      />
      <path
        opacity="0.2"
        d="M11.7248 5.60867H5.81372V18.9725H11.7248C12.3126 18.9706 12.7886 18.4949 12.7905 17.9075V6.67371C12.7886 6.0863 12.3126 5.61058 11.7248 5.60867Z"
        fill="black"
      />
      <path
        d="M1.06546 5.60867H11.7249C12.3134 5.60867 12.7906 6.0855 12.7906 6.67371V17.3264C12.7906 17.9146 12.3134 18.3915 11.7249 18.3915H1.06546C0.476887 18.3915 -0.000244141 17.9146 -0.000244141 17.3264V6.67371C-0.000244141 6.0855 0.476887 5.60867 1.06546 5.60867Z"
        fill="url(#microsoftexcel_paint0_linear_439_72406)"
      />
      <path
        d="M3.30042 15.4619L5.5423 11.9902L3.48821 8.53769H5.14055L6.26149 10.7456C6.36498 10.9554 6.43591 11.1111 6.47429 11.2139H6.48882C6.56246 11.0466 6.63998 10.8841 6.72138 10.7264L7.91964 8.53886H9.43652L7.3301 11.971L9.49002 15.4619H7.87605L6.58126 13.0384C6.52028 12.9353 6.46852 12.827 6.42662 12.7148H6.40743C6.3695 12.8247 6.31918 12.93 6.25743 13.0285L4.92428 15.4619H3.30042Z"
        fill="white"
      />
      <path
        d="M23.9343 0.379364H15.6976V6.18972H25V1.4444C25 0.856195 24.5229 0.379364 23.9343 0.379364Z"
        fill="hsl(from hsl(147 55% 29%) h s 62%)"
      />
      <path
        d="M15.6976 12.0001H25V17.8105H15.6976V12.0001Z"
        fill="hsl(from hsl(147 55% 29%) h s 38%)"
      />
    </g>
    <defs>
      <linearGradient
        id="microsoftexcel_paint0_linear_439_72406"
        x1="2.22178"
        y1="4.77647"
        x2="10.5607"
        y2="19.2282"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="hsl(from hsl(147 55% 29%) h s 33%)" />
        <stop offset="0.5" stopColor="hsl(from hsl(147 55% 29%) h s 40%)" />
        <stop offset="1" stopColor="hsl(from hsl(147 55% 29%) h s 31%)" />
      </linearGradient>
      <clipPath id="microsoftexcel_clip0_439_72406">
        <rect
          width="25.0002"
          height="23.2414"
          fill="white"
          transform="translate(-0.000244141 0.379364)"
        />
      </clipPath>
    </defs>
  </svg>
);
